// extracted by mini-css-extract-plugin
export var menuIcon = "_r1-0";
export var menuIconInline = "_r1-1";